module.exports = __webpack_public_path__ + "img/featuredartist (6).19879cb2.jpg";